import api from '../utils/api';

/**
 * Get user integrations
 */
export const getUserIntegrations = async () => {
    try {
        const response = await api.get('/integrations');
        return response.data;
    } catch (error) {
        console.error('Error fetching user integrations:', error);
        throw error;
    }
};

/**
 * Create integration
 */
export const createIntegration = async (integrationData) => {
    try {
        const response = await api.post('/integrations', integrationData);
        return response.data;
    } catch (error) {
        console.error('Error creating integration:', error);
        throw error;
    }
};

/**
 * Update integration
 */
export const updateIntegration = async (integrationId, integrationData) => {
    try {
        const response = await api.put(`/integrations/${integrationId}`, integrationData);
        return response.data;
    } catch (error) {
        console.error('Error updating integration:', error);
        throw error;
    }
};

/**
 * Delete integration
 */
export const deleteIntegration = async (integrationId) => {
    try {
        const response = await api.delete(`/integrations/${integrationId}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting integration:', error);
        throw error;
    }
};

/**
 * Get integration by ID
 */
export const getIntegrationById = async (integrationId) => {
    try {
        const response = await api.get(`/integrations/${integrationId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching integration:', error);
        throw error;
    }
};

export default {
    getUserIntegrations,
    createIntegration,
    updateIntegration,
    deleteIntegration,
    getIntegrationById
};
